import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const s = "image";
class m extends e {
  /**
   * Uploads an image using FormData.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/image`
   *
   * @param {FormData} formData - The image data to be uploaded.
   * @returns {Promise<UploadImageResponse>} A promise that resolves to the uploaded image response.
   */
  uploadImage = async (a) => {
    const { data: t } = await this.post(`${s}`, a, {
      "Content-Type": "multipart/form-data"
    });
    return t;
  };
}
export {
  s as IMAGE_RESOURCE_URI,
  m as Image
};
